module.exports = __webpack_public_path__ + "assets/img/1694cd00c98932846cd01e2792280aab.png";